(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!window.gsap || reduceMotion) return;

  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  const ease = "power3.out";

  const unused = (el) => el && !el.dataset.nfcIn;
  const mark = (el) => {
    el.dataset.nfcIn = "1";
  };

  const veil = document.querySelector(".nfc-page-veil");
  if (veil) gsap.to(veil, {
    autoAlpha: 0,
    duration: 0.7,
    ease: "power2.out",
    onComplete: () => veil.remove(),
  });

  const header = document.querySelector(".header-wrapper, .section-header");
  if (header && unused(header)) {
    mark(header);
    gsap.from(header, { y: -16, autoAlpha: 0, duration: 0.7, ease });
  }

  const fade = (nodes, vars) => {
    const list = [...nodes].filter(unused);
    list.forEach(mark);
    if (!list.length) return;
    gsap.from(list, vars);
  };

  const fadeUp = (selector, trigger, extra) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (!unused(el)) return;
      mark(el);
      gsap.from(el, {
        y: 28,
        autoAlpha: 0,
        duration: 0.95,
        ease,
        scrollTrigger: ScrollTrigger ? { trigger: trigger || el, start: "top 88%" } : undefined,
        ...extra,
      });
    });
  };

  const stagger = (parentSel, childSel, extra) => {
    document.querySelectorAll(parentSel).forEach((parent) => {
      const kids = [...parent.querySelectorAll(childSel)].filter(unused);
      kids.forEach(mark);
      if (!kids.length) return;
      gsap.from(kids, {
        y: 28,
        autoAlpha: 0,
        duration: 0.9,
        stagger: 0.07,
        ease,
        scrollTrigger: ScrollTrigger ? { trigger: parent, start: "top 86%" } : undefined,
        ...extra,
      });
    });
  };

  const kenBurns = (selector) => {
    document.querySelectorAll(selector).forEach((img) => {
      if (!unused(img) || !ScrollTrigger) return;
      mark(img);
      const pin = img.closest(".product__media, .collection-hero, .image-with-text__media") || img;
      gsap.fromTo(
        img,
        { scale: 1.1 },
        {
          scale: 1,
          ease: "none",
          scrollTrigger: { trigger: pin, start: "top 90%", end: "bottom top", scrub: true },
        }
      );
    });
  };

  const bind = () => {
    fade(document.querySelectorAll(".collection-hero__inner > *"), {
      y: 24,
      autoAlpha: 0,
      duration: 0.95,
      stagger: 0.1,
      ease,
    });

    stagger(".product-grid", ":scope > .grid__item");
    stagger(".collection-list", ".collection-list__item");
    stagger(".product__info-container", ":scope > *:not(.visually-hidden):not([hidden])", { delay: 0.12 });
    stagger("tbody", "tr.cart-item");

    fadeUp(".product__media-wrapper");
    fadeUp(".image-with-text");
    fadeUp(".product-recommendations");
    fadeUp(".cart__footer, .cart-items, .cart__contents");
    fadeUp(".footer");
    fadeUp(".title.title--primary");

    kenBurns(".product__media .nfc-bag, .product__media img, .collection-hero img, .image-with-text__media img");

    if (ScrollTrigger) ScrollTrigger.refresh();
  };

  bind();
  document.addEventListener("shopify:section:load", bind);
})();
